import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import messages from './i18n'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './utils/filter_utils.js'
import locale from 'element-ui/lib/locale/lang/ja'
import Vue from 'vue'
import VueCookies from 'vue-cookies'

import App from './App'
import router from './router'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.axios = axios

import qs from 'qs';
Vue.prototype.qs = qs;

Vue.use(VueI18n)
Vue.use(VueCookies)

// 设置统一的axios请求路径
// axios.defaults.baseURL = 'http://13.113.36.56/senseSys/'
// axios.defaults.baseURL = 'http://localhost:8080/senseSys/'
// 本番部署用
axios.defaults.baseURL = 'https://www.hrbox.jp/senseSys/'
// 定义元素的axios请求
Vue.prototype.$http = axios

const userLang = (navigator.language || navigator.userLang).split('-')[0]
const i18n = new VueI18n({
  locale: userLang,
  fallbackLocale: 'ja',
  messages,
})

window.bus = new Vue();
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n
})

// Vue.prototype.resetSetItem = function (key, newVal) {
//   if (key === 'watchStorage') {

//       // 创建一个StorageEvent事件
//       var newStorageEvent = document.createEvent('StorageEvent');
//       const storage = {
//           setItem: function (k, val) {
//               localStorage.setItem(k, val);

//               // 初始化创建的事件
//               newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

//               // 派发对象
//               window.dispatchEvent(newStorageEvent)
//           }
//       }
//       return storage.setItem(key, newVal);
//   }
// }





router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // } 
  const localeName = to.meta.localeName
  const type = to.meta.type
  //判断当前路由，设置禁用浏览器后退功能
  // if (localeName === "router.basic.homePage") {
    
  // }

  // 判断该路由是否需要登录权限
  if (type === 'login') {
    if (window.localStorage.getItem('LoginUserId') > 0 ) {
      next()
    } else {
      window.localStorage.removeItem('LoginUserId');
      next('/login')
    }
  } else {
    next()  // 确保一定要有next()被调用
  }
})



// WEBPACK FOOTER //
// ./src/main.js